import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { CreateState } from './types';

const initialState: CreateState = {
  pathway: null
};

export const slice = createSlice({
  name: 'create',
  initialState,
  reducers: {
    cleanPathway(state) {
      state.pathway = null;
    },
    getPathwaySuccess(state, action: PayloadAction<CreateState['pathway']>) {
      state.pathway = action.payload;
    }
  }
});

export default slice.reducer;
